import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Driver } from '../models/Driver'

type SaveDriverPayload = {
  driver: Record<string, unknown>
}

export const saveDriver = createAsyncThunk<Driver, SaveDriverPayload, ThunkApiContext>('drivers/saveDriver', async ({ driver }: SaveDriverPayload, { dispatch }) => {
  const response = await OLMSApiService.post<Driver>('driver/save', driver)

  if (!response) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Save driver',
      content: 'Failed to save driver',
    }))
    throw new Error('Failed to save driver')
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Save driver',
    content: `Successfully saved driver ${response.name} with login ${response.login}`,
  }))

  return response
})